import { DesignSchemeSet } from '@data/buildingProjects/DesignSchemeSet';
import FVector from '@data/geometry/FVector';
import { DesignSchemeRenderer } from '@rendering/DesignSchemes/DesignSchemeRenderer';
import { ConvexHullRenderer } from '@rendering/DesignSchemes/SingleVolume/ConvexHullRenderer';
import { ConvexHullDesignState, SchemeKey, type LayerKind } from '@visualizer/types';
import Layer from 'Simulations/Layer';
import { DesignScheme } from '../designScheme';

/**
 * DesignScheme subclass for convex hull single-volume generation.
 * Handles renderer initialization, Zustand synchronization, and visibility management.
 */
export class ConvexHull extends DesignScheme {
    constructor(
        footprint: FVector[],
        footprintId: string,
        set: DesignSchemeSet,
        config: ConvexHullDesignState,
        linkedLayers?: Map<LayerKind, Layer>
    ) {
        super(footprint, footprintId, set, config, linkedLayers);

        // Initialize visibility and update state:
        if (config.active) this.update();
    }

    // Renderer Factory & Defaults:
    protected override createRenderer(config: ConvexHullDesignState): DesignSchemeRenderer {
        return new ConvexHullRenderer(this, config);
    }

    override getRendererKey() {
        return SchemeKey.CONVEX_HULL;
    }
}
